import React, { useEffect, useState } from "react";

import { UsePlaceAuth } from "../../../AppContext/AppContext";
// import AdverSec from "../restaurent/adverSec/AdverSec";
import AppPromo from "../restaurent/appPromo/AppPromo";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link, useLocation, useNavigate } from "react-router-dom";
// import "react-tabs/style/react-tabs.css";
import Footer from "../../footer/Footer";
import moment from "moment";
import CarRentalBanner from "../CarRental/CarRentalBanner";
import Autocomplete from "react-google-autocomplete";
import FlightHomeBanner from "../Flight/FlightHomeBanner";
import HotelsHomeBanner from "../restaurent/bannerSec/hotels/HotelsHomeBanner";
import { apiData } from "../../../actions";
import brand1 from "../../../../src/demo/brand1.png";
import new1 from "../../../../src/demo/h3-slider01.png";
import new2 from "../../../../src/demo/h3-slider02.png";
import new3 from "../../../../src/demo/h3-slider03.png";
import new4 from "../../../../src/demo/h3-slider04.png";
import new5 from "../../../../src/demo/h3-slider05.png";
import new6 from "../../../../src/demo/h3-slider06.png";
import brand2 from "../../../../src/demo/brand2.png";
import brand5 from "../../../../src/demo/brand5.png";
import brand6 from "../../../../src/demo/brand6.png";
import travel from "../../../../src/images/aps.png";
import multipleCars from "../../../../src/demo/multipleCars.png";
import axios from "axios";
import wifi from "../../../demo/wifi.png";
import ContactModal from "../../Modals/ContactModal";
import LoginModal from "../../Modals/LoginModal";
import { Audio_Tour, Car_Rentals, Hotel, Restaurants, Things_to_do, _Blog_, _Deals_, setPlace } from "../../../Redux/Action/Action";
import { useDispatch, useSelector } from "react-redux";
import BlogMain from "../blog/BlogMain";
import RegLoginModal from "../../Modals/RegLoginModal";
import NewDeal from "../deals/NewDeal";
import { toast } from "react-toastify";
import Header from "../../header/Header";

function Home() {
    const place = useSelector(state => state.place);
    const [selectedCity, setSelectedCity] = useState("Choose City");
    const [relaxingData, setRelaxingData] = useState([]);
    const [loader, setLoader] = useState(false);
    let navigate = useNavigate();
    const { activeTab, setActiveTab } = UsePlaceAuth();
    const [dealsData, setDealsData] = useState([]);
    const [CoolDeals, setCoolDeals] = useState([]);
    const [inclusiveDeals, setInclusiveDeals] = useState([]);
    const [hotelClick, setHotelClick] = useState(false);
    const [flightClick, setFlightClick] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [firstBlog, setFirstBlog] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [contactModal, SetContactModal] = useState(false);
    const [loginModal, setLoginModal] = useState(false);
    const [regLoginModal, setRegLoginModal] = useState(false);
    // let { hotelUrl, setHotelUrl } = UsePlaceAuth();
    const [city, setCity] = useState('');
    let { flightUrl, setFlightUrl } = UsePlaceAuth();
    const itemsPerPage = 6;
    // const [hasMoreItems, sethasMoreItems] = useState(true);
    const [records, setrecords] = useState(itemsPerPage);
    const [homeClick, setHomeClick] = useState("0");
    const dispatch = useDispatch();
    let location = useLocation();

    const GetCities = async () => {
        setLoader(true);
        let apiRes = await apiData.RelaxingCities();
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setRelaxingData(apiRes?.data?.data);
            setLoader(false);
        }
        if (apiRes?.status >= 400 && apiRes?.status <= 500) {
            console.log("error");
        }
    };
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const storedUserName = localStorage.getItem('userName');
        if (storedUserName) {
            setUserName(storedUserName);
            setIsLoggedIn(true);
        }
    }, []);


    const GetDeals = async () => {
        axios
            .get(
                `${process.env.REACT_APP_BASE_URL}all-inclusive-deals?city=Caribbean&keyword=resort&limit=80`
            )
            .then((response) => {
                // console.log("response", response);
                setDealsData(
                    response?.data?.data?.data?.travelExperienceProducts?.resultList
                );
            });
        setLoader(true);
    };

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const cityFromUrl = query.get('city');

        if (cityFromUrl) {
            setCity(cityFromUrl);
            CallApi(cityFromUrl);
        }
    }, [location]);

    const CallApi = async (city) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}flight-url?city=${city}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.data?.length > 0) {
                const flightUrl = response.data.data[0].url;
                setFlightUrl(flightUrl);
                window.location.href = flightUrl;
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (location.pathname === '/') {
            setActiveTab("")
        }

    }, [])

    const handleClick = () => {
        //  setLoginModal(true);
        setRegLoginModal(true);
    };


    useEffect(() => {
        const userName = localStorage.getItem("userName"); // Check if the user is logged in
        const hasSeenPopup = localStorage.getItem("hasSeenPopup");

        if (!userName && !hasSeenPopup) {
            setLoginModal(true);
            localStorage.setItem("hasSeenPopup", "true");
        }

        // Save a timestamp when the user navigates away
        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                // If the user is leaving the tab
                localStorage.setItem("lastSeen", Date.now());
            } else if (document.visibilityState === "visible") {
                // If the tab becomes visible again
                const lastSeen = localStorage.getItem("lastSeen");
                if (lastSeen && Date.now() - lastSeen > 1000) {
                    // Clear localStorage if it seems the user closed the tab
                    localStorage.removeItem("hasSeenPopup");
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    const cityCodes = {
        'Chicago': 'CHI', 'Los Angeles': 'LAX', 'San Francisco': 'SFO', 'Miami': 'MIA', 'Las Vegas':
            'LAS', 'Boston': 'BOS', 'Seattle': 'SEA', 'Dallas': 'DFW', 'Atlanta': 'ATL', 'Orlando': 'MCO', 'Philadelphia': 'PHL', 'San Diego':
            'SAN', 'New York': 'NYC', 'Nashville': 'BNA', 'Houston': 'IAH', 'New Orleans': 'MSY', 'Denver': 'DEN', 'Phoenix': 'PHX',
        'Austin': 'AUS', 'Charlotte': 'CLT', 'Tampa': 'TPA', 'Portland': 'PDX', 'Salt Lake City': 'SLC',
        'San Antonio': 'SAT', 'Minneapolis': 'MSP', 'St Louis': 'STL', 'Charleston': 'CHS', 'Savannah': 'SAV', 'Honolulu': 'HNL'
    };

    const GetInclusiveDeals = async () => {
        setLoader(true);
        let payload = {
            city: place,
            keyword: "Adventure",
            limit: 12,
        };
        let apiRes = await apiData.getRandomDeals(payload);
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setInclusiveDeals(apiRes?.data?.data);
            setLoader(false);
        }
        if (apiRes?.status >= 400 && apiRes?.status <= 500) {
            console.log("error");
        }
    };
    const CoolFlightDeals = async () => {
        setLoader(true);
        let apiRes = await apiData.coolFlightDeals();
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setCoolDeals(apiRes?.data?.data);
            setLoader(false);
        }
        if (apiRes?.status >= 400 && apiRes?.status <= 500) {
            console.log("error");
        }
    };
    const handleSearch = (e) => {
        if (e.key.toLowerCase() == "enter") {
            e.preventDefault();
            if (activeTab == 1) {
                const citySlug = e.target.value.split(",")[0].toLowerCase();
                if (location.pathname.startsWith('/experiences/')) return;
                navigate(`/hotel/${citySlug}`);
                dispatch(setPlace(citySlug));
                dispatch(Hotel());
            }
            if (activeTab == 4) {
                navigate(`/restaurant/${e.target.value.split(",")[0].toLowerCase()}`);
                if (window.screen.width < 800) window.location.reload();
                dispatch(setPlace(e.target.value.toLowerCase()));
                dispatch(Restaurants())
            }
            if (activeTab == 5) {
                navigate(`/things-to-do/${e.target.value.split(",")[0].toLowerCase()}`);
                if (window.screen.width < 800) window.location.reload();
                dispatch(setPlace(e.target.value.toLowerCase()));
                dispatch(Things_to_do())
            }
            if (activeTab == 6) {
                navigate(`/audio-tour/${e.target.value.split(",")[0].toLowerCase()}`);
                if (window.screen.width < 800) window.location.reload();
                dispatch(setPlace(e.target.value.toLowerCase()));
                dispatch(Audio_Tour())
            }
            if (activeTab == 7) {
                navigate(`/deals/${e.target.value.split(",")[0].toLowerCase()}`);
                if (window.screen.width < 800) window.location.reload();
                dispatch(setPlace(e.target.value.toLowerCase()));
                dispatch(_Deals_())
            }
        }
    };
    /* specific home page blogs listing api  -------*/
    let loadMore = async () => {
        let payload = {
            key: keyword
        }
        let apiRes = await apiData.blog(payload);
        if (apiRes?.status >= 200 && apiRes?.status <= 399) {
            setLoader(true);
            setBlogs(apiRes?.data?.data);
            setFirstBlog(apiRes?.data?.data[0])
            setLoader(false);
            if (records >= apiRes?.data?.data.length) {
                // sethasMoreItems(false);
            } else {
                setTimeout(() => {
                    setrecords(records + itemsPerPage);
                }, 2000);
            }
        }
        else {
            console.log("server error")
        }

    };

    const options123 = {
        items: 4,
        loop: true,
        autoplay: true,
        slidesToShow: 4,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            991: {
                items: 4
            }
        }
    };
    useEffect(() => {
        loadMore();
    }, [keyword]);

    useEffect(() => {
        GetCities();
        GetDeals();
        GetInclusiveDeals();
        CoolFlightDeals();

    }, [place]);

    const responsive321 = {
        items: 4,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            992: {
                items: 4
            }
        }
    };
    const responsiveSetting1 = {
        items: 4,
        loop: true,
        autoplay: true,
        slidesToShow: 4,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            991: {
                items: 4
            }
        }
    };

    const optionsAll = {
        items: 4,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            991: {
                items: 3
            }
        }
    };

    useEffect(() => {
        dispatch(Car_Rentals())
    }, [place]);
    useEffect(() => { }, [activeTab]);
    const [typedText, setTypedText] = useState("");
    const [charIndex, setCharIndex] = useState(0);
    const [isTyping, setIsTyping] = useState(true);

    const textArray = ["Uncover Stunning\nDestinations with Us!"];
    const typingDelay = 2;
    const newTextDelay = 2000;
    useEffect(() => {
        let timeoutId;

        if (isTyping) {
            if (charIndex < textArray[0].length) {
                timeoutId = setTimeout(() => {
                    setTypedText((prev) => prev + textArray[0].charAt(charIndex));
                    setCharIndex(charIndex + 1);
                }, typingDelay);
            } else {
                setIsTyping(false);
                timeoutId = setTimeout(() => {
                    setIsTyping(true);
                    setTypedText("");
                    setCharIndex(0);

                    window.scroll({
                        top: 0,
                        behavior: 'smooth',
                    });
                }, newTextDelay);
            }
        }

        return () => clearTimeout(timeoutId);
    }, [charIndex, isTyping]);

    const renderText = () => {
        return typedText.split('\n').map((line, index) => (
            <span key={index} style={{ display: 'block' }}>{line}</span>
        ));
    };
    useEffect(() => {
        window.scroll({
            top: 0,
            behavior: 'smooth',
        });
    }, []);

    const handleButtonDisability = () => { };
    const [isToggled, setIsToggled] = useState(false);

    const toggleElements = () => {
        setIsToggled(!isToggled);
    };

    const handleLogout = () => {
        localStorage.removeItem('userName');
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('selectedCity');
        setUserName(null);
        setIsLoggedIn(false); // Reset state
    };
    const pathPrefixes = [
        'hotel',
        'flight',
        'car-rental',
        'restaurant',
        'things-to-do',
        'experiences',
        'audio-tour',
        'deal',
        'blog'
    ];

    // Extracts the city slug from the URL if it matches a known path prefix
    const extractPlace = (pathname) => {
        const pathSegments = pathname.split('/').filter(Boolean);

        if (pathSegments.length >= 2 && pathPrefixes.includes(pathSegments[0])) {
            return pathSegments[1]; // This is the :sub (city slug)
        }

        return null;
    };

    useEffect(() => {
        const citySlug = extractPlace(location.pathname);

        if (citySlug) {
            // Normalize and match against city names in cityCodes
            const matchedCity = Object.keys(cityCodes).find((cityName) => {
                const citySlugified = cityName.toLowerCase().replace(/\s+/g, '-');
                return citySlugified === citySlug.toLowerCase();
            });

            if (matchedCity) {
                setSelectedCity(matchedCity); // Set display name like "New York"
            } else {
                setSelectedCity('Choose City'); // fallback
            }
        } else {
            const stored = localStorage.getItem('selectedCity');
            setSelectedCity(stored && stored !== 'undefined' ? stored : 'Choose City');
        }
    }, [location.pathname]);


    const localSelectedCity = localStorage.getItem('selectedCity');

    return (
        <div key={homeClick}>
            <Header />
            <div className="checkbox-sec">
                {activeTab == 1 && (
                    <HotelsHomeBanner />
                )}
                {activeTab == 2 && (<div
                    className="tab-pane fade show"
                    id="hotel-tab-pane"
                    role="tabpanel"
                    aria-labelledby="hotel-tab"
                    tabIndex="0"
                >
                    <FlightHomeBanner />
                </div>)}

                {activeTab == 3 && (
                    <div className="select-form car-rental">
                        <CarRentalBanner />

                    </div>

                )}

                {activeTab == 4 && (
                    <div className="banner-sec">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-inner">
                                        <div data-aos="zoom-in-right" className="banner-content">
                                            <img loading="lazy" src={travel} alt="travel" />
                                            <h2>Uncover Stunning Destinations with Us!</h2>
                                            <p><span>Your Dream Trip Awaits!</span>
                                                Thinking of escaping the daily grind? Relax, we’ve got your dream trip covered!</p>
                                        </div>
                                        <div data-aos="zoom-in-left" className="banner-images">
                                            <ul>
                                                <li>
                                                    <img loading="lazy" src={new1} alt="banner" />
                                                    <img loading="lazy" src={new2} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new3} alt="banner" />
                                                    <img loading="lazy" src={new4} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new5} alt="banner" />
                                                    <img loading="lazy" src={new6} alt="banner" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="search-bar">
                                            <Autocomplete
                                                className="form-control"
                                                apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                placeholder={
                                                    localSelectedCity && localSelectedCity !== "undefined" && place
                                                        ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                        : "Where would you like to go"
                                                }

                                                onPlaceSelected={async (city) => {
                                                    await navigate(
                                                        `/restaurant/${city.formatted_address
                                                            .split(",")[0]
                                                            .toLowerCase()}`
                                                    );

                                                    dispatch(setPlace(city.formatted_address.split(",")[0].toLowerCase()));
                                                    dispatch(Restaurants())
                                                }}
                                                onKeyPress={handleSearch}
                                            />


                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab == 5 && (
                    <div className="banner-sec">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-inner">
                                        <div data-aos="zoom-in-right" className="banner-content">
                                            <img loading="lazy" src={travel} alt="banner" />
                                            <h2>Uncover Stunning Destinations with Us!</h2>
                                            <p><span>Your Dream Trip Awaits!</span>
                                                Thinking of escaping the daily grind? Relax, we’ve got your dream trip covered!</p>
                                        </div>
                                        <div data-aos="zoom-in-left" className="banner-images">
                                            <ul>
                                                <li>
                                                    <img loading="lazy" src={new1} alt="banner" />
                                                    <img loading="lazy" src={new2} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new3} alt="banner" />
                                                    <img loading="lazy" src={new4} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new5} alt="banner" />
                                                    <img loading="lazy" src={new6} alt="banner" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="search-bar">
                                            <Autocomplete
                                                className="form-control"
                                                apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                placeholder={
                                                    localSelectedCity && localSelectedCity !== "undefined" && place
                                                        ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                        : "Where would you like to go"
                                                }
                                                onPlaceSelected={async (city) => {
                                                    await navigate(
                                                        `/things-to-do/${city.formatted_address
                                                            .split(",")[0]
                                                            .toLowerCase()}`
                                                    );
                                                    if (window.screen.width < 800) {
                                                        window.location.reload();
                                                    }
                                                    dispatch(setPlace(city.formatted_address.split(",")[0].toLowerCase()));
                                                    dispatch(Restaurants())
                                                }}
                                                onKeyPress={handleSearch}
                                            />


                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab == 6 && (
                    <div className="banner-sec">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-inner">
                                        <div data-aos="zoom-in-right" className="banner-content">
                                            <img loading="lazy" src={travel} alt="travel" />
                                            <h2>Uncover Stunning Destinations with Us!</h2>
                                            <p><span>Your Dream Trip Awaits!</span>
                                                Thinking of escaping the daily grind? Relax, we’ve got your dream trip covered!</p>
                                        </div>
                                        <div data-aos="zoom-in-left" className="banner-images">
                                            <ul>
                                                <li>
                                                    <img loading="lazy" src={new1} alt="banner" />
                                                    <img loading="lazy" src={new2} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new3} alt="banner" />
                                                    <img loading="lazy" src={new4} alt="banner" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new5} alt="banner" />
                                                    <img loading="lazy" src={new6} alt="banner" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="search-bar">
                                            <Autocomplete
                                                className="form-control"
                                                apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                placeholder={
                                                    localSelectedCity && localSelectedCity !== "undefined" && place
                                                        ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                        : "Where would you like to go"
                                                }
                                                onPlaceSelected={async (city) => {
                                                    await navigate(
                                                        `/audio-tour/${city.formatted_address
                                                            .split(",")[0]
                                                            .toLowerCase()}`
                                                    );
                                                    if (window.screen.width < 800) {
                                                        window.location.reload();
                                                    }
                                                    dispatch(setPlace(city.formatted_address.split(",")[0].toLowerCase()));
                                                    dispatch(Restaurants())
                                                }}
                                                onKeyPress={handleSearch}
                                            />

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab == 7 && (
                    <NewDeal />
                )}

                {/* not active tab search button listing */}
                {!activeTab &&
                    <div className="banner-sec">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="banner-inner">
                                        <div data-aos="zoom-in-right" className="banner-content">
                                            <img loading="lazy" src={travel} alt="travel" />
                                            {/* <h2>Uncover Stunning Destinations with Us!</h2> */}
                                            <h2>
                                                <span className="typed-text">{renderText()}</span>
                                                <span className="cursor"></span>
                                            </h2>
                                            <p><span>Your Dream Trip Awaits!</span>
                                                Thinking of escaping the daily grind? Relax, we’ve got your dream trip covered!</p>
                                        </div>
                                        <div data-aos="zoom-in-left" className="banner-images">
                                            <ul>
                                                <li>
                                                    <img loading="lazy" src={new1} alt="images" />
                                                    <img loading="lazy" src={new2} alt="images" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new3} alt="images" />
                                                    <img loading="lazy" src={new4} alt="images" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={new5} alt="images" />
                                                    <img loading="lazy" src={new6} alt="images" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="search-bar">
                                            <Autocomplete
                                                className="form-control"
                                                apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                                placeholder={
                                                    "Where would you like to go"
                                                }
                                                onPlaceSelected={async (city) => {
                                                    const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                    // Update route
                                                    await navigate(`/hotel/${selectedCity}`);

                                                    // Dispatch Redux actions
                                                    dispatch(setPlace(selectedCity));
                                                    dispatch(Restaurants());
                                                }}
                                                onKeyPress={handleSearch}
                                            />

                                            {/* <a href="#"><img loading="lazy" src="images/Search.svg" /> Search</a> */}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                }

            </div>
            {activeTab == "8" ? (
                <BlogMain />
            ) : (activeTab == "7" ? (
                <div>
                    <div className="itemBox">
                        <div className="rind-the-right-section comedy-sec">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="white-box-area inner rest-deals">
                                            <div className="row">
                                                <div className="col-lg-12 col-12">
                                                    <section className="client-sec comedy">
                                                        {
                                                            <div className="testimonial-section products">
                                                                <div data-aos="zoom-in-right" className="head-yelp">
                                                                    <h3>Our Featured Deals</h3>
                                                                    <p>Find exclusive deals for you destination</p>
                                                                </div>
                                                                <div className="row feat-blogs-head">
                                                                    {dealsData &&
                                                                        dealsData?.map((ele) => {
                                                                            return (
                                                                                <div
                                                                                    data-aos="zoom-in-right"
                                                                                    className="col-12 col-sm-6 col-md-4 col-lg-4 mb-4"
                                                                                    key={ele?.id}
                                                                                >
                                                                                    <a href={ele?.link} target="_blank" rel="noreferrer">
                                                                                        <div className="cities">
                                                                                            <img loading="lazy"
                                                                                                src={ele?.imageLink}
                                                                                                alt="deals"
                                                                                            />
                                                                                            <div className="offer-details">
                                                                                                <h6>
                                                                                                    {ele?.title?.slice(0, 15)}
                                                                                                </h6>
                                                                                                <p>
                                                                                                    {ele?.description?.slice(0, 20)}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="offer-action">
                                                                                                <a className="siti-btn full">Book Now</a>
                                                                                                {/* <a href="#/">T&C’s Apply</a> */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </div>
                                                        }
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>

                    <div className="feature-sec blue-back">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div data-aos="zoom-in-right" className="feature-inner">
                                        <div className="tri-icon-svg">
                                            <img src="/images/svg1.png" alt="" />
                                        </div>

                                        <div className="feature-content">
                                            <h4>Your Dream Getaway Awaits!
                                            </h4>
                                            <p>Find amazing deals on flights, hotels, and tours! Start planning your dream getaway today!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div data-aos="zoom-in-left" className="feature-inner">
                                        {/* <img loading="lazy" src="images/feat2.svg" alt="images" /> */}
                                        <div className="tri-icon-svg">
                                            <img src="/images/svg2.png" alt="" />
                                        </div>

                                        <div className="feature-content">
                                            <h4>Immersive Audio Tours</h4>
                                            <p>Enhance your vacation with our immersive audio tours! Learn about your destination anytime and explore our tour deals for an unforgettable experience!</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4">
                                    <div data-aos="zoom-in-right" className="feature-inner">
                                        {/* <img loading="lazy" src="images/feat3.svg" alt="images" /> */}
                                        <div className="tri-icon-svg">
                                            <img src="/images/svg3.png" alt="" />
                                        </div>

                                        <div className="feature-content">
                                            <h4>Your Bucket List Adventure</h4>
                                            <p>Book your ultimate adventure with G-Adventures world tours! Complete your bucket list, visit world destinations, and create unforgettable memories. Start your journey now!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {activeTab == "3" ? (
                        <div>
                            <div className="flight-sec flight_sec_2">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12">
                                            <div className="slider-sec">
                                                <div data-aos="zoom-in-left" className="slider-header">
                                                    <h2>Flight Specials</h2>
                                                    {/* <a href="#">View More <img loading="lazy" src="images/right.svg" alt="Right Arrow" /></a> */}
                                                </div>
                                                <p data-aos="zoom-in-right">Hey there! Picture this – vibing in the hustle of New York City, soaking up the starry vibes in Los Angeles, exploring architectural wonders in Chicago, or just chilling on the sunny beaches of Miami. Our Flight Specials make it all possible! Score unbeatable airfare deals, turn your travel dreams into reality, and let's make some epic memories together. Come on, let's take flight and create unforgettable experiences! ✈️</p>
                                                <div data-aos="zoom-in-left" className="slider-main">
                                                    <OwlCarousel
                                                        className="owl-carousel owl-theme"
                                                        {...responsive321}

                                                    >
                                                        {CoolDeals && CoolDeals.map((deal, index) => (
                                                            <div key={index} className="testimonial-block product">
                                                                <a href={deal.url} target="_blank" rel="noreferrer">
                                                                    <div className="discount-block">
                                                                        <img loading="lazy" src={deal.image_url} alt="Deal" />
                                                                        <h3>{deal.title}</h3>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </OwlCarousel>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="car-sec">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-md-12 col-lg-12">
                                            <h2>Rent With Companies You Know and Trust</h2>
                                            <ul>
                                                <li>
                                                    <img loading="lazy" src={brand1} alt="Brand 1" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={brand2} alt="Brand 2" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={brand5} alt="Brand 5" />
                                                </li>
                                                <li>
                                                    <img loading="lazy" src={brand6} alt="Brand 6" />
                                                </li>
                                            </ul>

                                            <img loading="lazy" src={multipleCars} alt="multipleCars" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (<div className="flight-sec flight_sec_2">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <div className="slider-sec">
                                        <div data-aos="zoom-in-left" className="slider-header">
                                            <h2>Flight Specials</h2>
                                            {/* <a href="#">View More <img loading="lazy" src="images/right.svg" alt="Right Arrow" /></a> */}
                                        </div>
                                        <p data-aos="zoom-in-right">Hey there! Picture this – vibing in the hustle of New York City, soaking up the starry vibes in Los Angeles, exploring architectural wonders in Chicago, or just chilling on the sunny beaches of Miami. Our Flight Specials make it all possible! Score unbeatable airfare deals, turn your travel dreams into reality, and let's make some epic memories together. Come on, let's take flight and create unforgettable experiences! ✈️</p>
                                        <div data-aos="zoom-in-left" className="slider-main">
                                            <OwlCarousel
                                                className="owl-carousel owl-theme"
                                                {...responsive321}

                                            >
                                                {CoolDeals && CoolDeals.map((deal, index) => (
                                                    <div key={index} className="testimonial-block product">
                                                        <a href={deal.url} target="_blank" rel="noreferrer">
                                                            <div className="discount-block">
                                                                <img loading="lazy" src={deal.image_url} alt="Deal" />
                                                                <h3>{deal.title}</h3>
                                                            </div>
                                                        </a>
                                                    </div>
                                                ))}
                                            </OwlCarousel>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>)}
                    {activeTab == "3" ? (
                        <div>

                        </div>
                    ) : (
                        <div>
                            <div className="flight-sec blue-back inclusive">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-md-9 col-lg-9">
                                            <div className="slider-sec">
                                                <div data-aos="zoom-in-right" className="slider-header">
                                                    <h2>All-Inclusive Resorts</h2>

                                                </div>
                                                <p data-aos="zoom-in-right">Get set for an incredible journey with our All-Inclusive Resort Discounts!
                                                    Picture yourself in a world of pure luxury, relishing amazing cuisine, and diving into endless adventures at a resort paradise. These moments are pure magic and will leave you hungry for more excitement and adventure. Ready to jump into the thrill? Seize these fantastic deals and let the adventure begin! 🌴🌟</p>
                                                <div data-aos="zoom-in-right" className="slider-main">
                                                    {dealsData && dealsData.length > 0 ? (
                                                        <OwlCarousel className="owl-carousel owl-theme" {...optionsAll}>
                                                            {dealsData.map((ele) => (
                                                                <div key={ele.id} className="slider-block inclusive-price">
                                                                    <a href={ele.link} target="_blank" rel="noreferrer">
                                                                        <img loading="lazy" src={ele.imageLink} alt="All-Inclusive" />
                                                                        <div className="rating">
                                                                            <div className="stars">
                                                                                <div className="reviews-no">
                                                                                    <p>4.0</p>
                                                                                </div>
                                                                                <p>
                                                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                                                    <i className="fa fa-star" aria-hidden="true"></i>
                                                                                </p>
                                                                                <p className="riview-last">
                                                                                    <img loading="lazy" src={wifi} alt="wifi" />
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="slider-content">
                                                                            <div className="slider-content-inner text-start ps-0">
                                                                                <h3>{ele.title.slice(0, 17)}</h3>
                                                                                <p>{ele.description.slice(0, 25)}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="review-sec">
                                                                            <p className="d-flex gap-2">
                                                                                    {ele?.price?.amount !== ele?.salePrice?.amount ? (
                                                                                        <>
                                                                                            <span className="old-price">${ele?.price?.amount}</span>{" "}
                                                                                            <span className="new-price">${ele?.salePrice?.amount}</span>{" "}
                                                                                            <span className="dis-percent">

                                                                                                {(() => {
                                                                                                    const originalPrice = Number(ele?.price?.amount);
                                                                                                    const salePrice = Number(ele?.salePrice?.amount);
                                                                                                    const discount =
                                                                                                        originalPrice && salePrice
                                                                                                            ? Math.max(0, Math.round(((originalPrice - salePrice) / originalPrice) * 100))
                                                                                                            : 0;
                                                                                                    return `-${discount}%`;
                                                                                                })()}
                                                                                            </span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <span className="new-price">${ele?.salePrice?.amount}</span>
                                                                                    )}
                                                                                </p>
                                                                            <a className="siti-btn">
                                                                                Book Now
                                                                            </a>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </OwlCarousel>
                                                    ) : (
                                                        <div>Oops! The data is not available.</div>
                                                    )}


                                                </div>


                                            </div>
                                        </div>
                                        <div className="col-12 col-md-3 col-lg-3">
                                            <a
                                                href="https://www.jdoqocy.com/click-101096032-15534704"
                                                target="_top"
                                            >
                                                <div data-aos="zoom-in-right" className="offer-sec">
                                                    <img loading="lazy" src="https://www.awltovhc.com/image-101096032-15534704" alt="Offer" />
                                                    <div className="offer-content">
                                                        <p>This week only! <span>Enjoy 50% Off</span> and free cancellation</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flight-sec full-sec inclusive">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-md-12 col-lg-12">
                                            <div className="slider-sec">
                                                <div data-aos="zoom-in-right" className="slider-header">
                                                    <h2>Cruise Package Deals</h2>
                                                </div>
                                                <p data-aos="zoom-in-left">Imagine indulging in mouthwatering dining, unwinding in pure relaxation, and diving into thrilling adventures—all while cruising through breathtaking destinations. Our Cruise Package Deals bring all this to life! Get ready for a dream cruise adventure with unmatched hospitality and stunning views. Your next incredible voyage is calling – let’s set sail and make memories together!</p>
                                                <div data-aos="zoom-in-right" className="slider-main">
                                                    <OwlCarousel
                                                        className="owl-carousel owl-theme"
                                                        {...responsiveSetting1}
                                                    >
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15731470">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/south america.jpeg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>South America Cruise</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.anrdoezrs.net/click-8265264-15731471">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/d20cr0y5lovqgrjaoosj.jpeg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Pacific Coastal Cruise </h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-13096760">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Europe_Hero_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Europe Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15731473">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/eastern mediterrnean.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3> Eastern Mediterranean Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15535742">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/oceania-cruises-marina1.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Oceania Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>

                                                        <div className="testimonial-block product">
                                                            <a href="https://www.tkqlhce.com/click-8265264-15535758">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/world cruise.webp`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Uniworld River Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.dpbolvw.net/click-8265264-13096769">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Panama_Canal-HERO_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Panama Canal Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.dpbolvw.net/click-8265264-15534698">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Mexico_Xelha_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Mexico Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.tkqlhce.com/click-8265264-10929173">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Western_Mediterranean_Hero5_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Mediterranean Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.dpbolvw.net/click-8265264-15533910">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Hawaii_Hero_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Hawaii Cruise</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.dpbolvw.net/click-8265264-15534035">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Europe_Hero_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>European cruises </h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.anrdoezrs.net/click-8265264-15534704">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Caribbean_Hero_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Caribbean Cruises </h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.tkqlhce.com/click-8265264-15533810">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/portland_Maine_lighthouse-hero_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Canada/New England Cruise</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15534707">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/horseshoe_beach-HERO_20_1_.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Bermuda Cruise</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15534709">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Bahamas_hero_0_1_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Bahamas Cruise</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.anrdoezrs.net/click-8265264-10504131">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Orient_Far_East_Hero3_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Asian Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>


                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-15533884">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/Alaksa_Cruises_0.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Alaska Cruises</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>

                                                        <div className="testimonial-block product">
                                                            <a href="https://www.tkqlhce.com/click-8265264-10493749">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/last-minute-cruises.jpg`}
                                                                        alt="Last-minute"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Last-minute</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.kqzyfj.com/click-8265264-10678374">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/family-cruises.jpg`}
                                                                        alt="Family"
                                                                    />

                                                                    <div className="offer-action">
                                                                        <h3>Family</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="testimonial-block product">
                                                            <a href="https://www.jdoqocy.com/click-8265264-10281267">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/honeymoon.png`}
                                                                        alt="Honeymoon"
                                                                    />

                                                                    <div className="offer-action">
                                                                        <h3>Honeymoon</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>

                                                        <div className="testimonial-block product">
                                                            <a href="https://www.anrdoezrs.net/click-8265264-13312047">
                                                                <div className="discount-block">
                                                                    <img loading="lazy"
                                                                        src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/ncl_Bliss_Haven_Observ_Lounge_Dk17_Sofa_View.jpg`}
                                                                        alt="Couple"
                                                                    />
                                                                    <div className="offer-action">
                                                                        <h3>Couple</h3>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        {/* Add more testimonial-block elements here */}
                                                    </OwlCarousel>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flight-sec blue-back inclusive">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-md-12 col-lg-12">
                                            <div className="slider-sec">
                                                <div data-aos="zoom-in-right" className="slider-header">
                                                    <h2>Relaxing Beach Gateways</h2>
                                                    {/* <a href="#">View More <img loading="lazy" src="images/right.svg" alt="" /></a> */}
                                                </div>
                                                <p data-aos="zoom-in-left">Get set for an incredible journey with our All-Inclusive Resort Discounts! Picture yourself in a world of pure luxury, relishing amazing cuisine, and diving into endless adventures at a resort paradise. These moments are pure magic and will leave you hungry for more excitement and adventure. Ready to jump into the thrill? Seize these fantastic deals and let the adventure begin!</p>
                                                <div data-aos="zoom-in-right" className="slider-main">
                                                    <OwlCarousel
                                                        className="owl-carousel owl-theme"
                                                        {...options123}
                                                    >
                                                        {relaxingData &&
                                                            relaxingData.map((ele, index) => (
                                                                <div key={index} className="testimonial-block product">
                                                                    <a href={ele?.url} target="_blank" rel="noreferrer">
                                                                        <div className="discount-block">
                                                                            <img loading="lazy" src={`${ele?.image_url}`} alt="blog" />
                                                                            <div className="blog-content home beach-desc-sec">
                                                                                <div className="date-sec">
                                                                                    <h5> {ele?.name.length >= 18 ? `${ele.name.slice(0, 18)}...` : ele?.name}</h5>

                                                                                    <p>{ele?.description.slice(0, 55)}..</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            ))}
                                                    </OwlCarousel>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flight-sec full-sec inclusive">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-md-12 col-lg-12">
                                            <div className="slider-sec without-para">
                                                <div data-aos="zoom-in-right" className="slider-header">
                                                    <h2>Want to see the World</h2>
                                                </div>

                                                <div data-aos="zoom-in-right" className="slider-main">
                                                    <div >
                                                        <OwlCarousel className="owl-carousel owl-theme" {...options123}>
                                                            {inclusiveDeals &&
                                                                inclusiveDeals.map((ele) => {
                                                                    return (
                                                                        <div className="testimonial-block product" key={ele.id}>
                                                                            <a href={ele?.link} target="_blank" rel="noreferrer">
                                                                                <div className="discount-block">

                                                                                    <img loading="lazy"
                                                                                        src={`${ele?.image}`}
                                                                                        // style={{ width: "100%", height: "300PX" }}
                                                                                        alt="Beach-Gateways"
                                                                                    />
                                                                                    <h3>{ele?.title}</h3>

                                                                                </div>
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </OwlCarousel>
                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>


                    )}
                </div>
            ))}
            <AppPromo />
            {activeTab != "8" ? (
                <div className="flight-sec blog-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12">

                                <div >
                                    <div data-aos="zoom-in-right" className="slider-sec">
                                        <div className="slider-header">
                                            <h2>Blogs & Resources</h2>
                                            <Link to={place ? `/blog/${place}` : `/blog`}>View More <img src="/images/right.svg" alt="View More" /></Link>
                                        </div>
                                        <p>Find fun places to see and things to do experience the art, museums, music, zoos</p>
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-md-6 col-lg-6" onClick={() => navigate(`/blog/${firstBlog.slug}`)}>
                                <div data-aos="zoom-in-left" className="blog-main">
                                    <div className="left_blog_img">
                                        <img loading="lazy" src={firstBlog.image} alt="blog" />
                                    </div>

                                    <div className="blog-content">
                                        <div className="date-sec">
                                            <p><img src="/images/Calendar.svg" alt="" /> {moment(firstBlog.date).format("MMMM Do YYYY")}</p>
                                            <h4><a href="#">{firstBlog.title}</a></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-6">
                                <div className="small-blog">
                                    {blogs.slice(1, 5).map((ele, index) => (
                                        <div key={index} data-aos="zoom-in-right" className="blog-main" onClick={() => navigate(`/blog/${ele.slug}`)}>
                                            <div className="right_blog_img">
                                                <img loading="lazy" src={ele?.image} alt="blog" />
                                            </div>
                                            <div className="blog-content home">
                                                <div className="date-sec">
                                                    <p><img src="/images/Calendar.svg" alt="Calendar" /> {moment(ele.date).format("MMMM Do YYYY")}</p>
                                                    <h4><a href="#">{ele?.title}</a></h4>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}

            <Footer />
            {contactModal && (
                <ContactModal
                    contactModal={contactModal}
                    SetContactModal={SetContactModal}
                />
            )}
            {loginModal && (
                <LoginModal
                    loginModal={loginModal}
                    setLoginModal={setLoginModal}
                />
            )}
            {regLoginModal && (
                <RegLoginModal
                    regLoginModal={regLoginModal}
                    setRegLoginModal={setRegLoginModal}
                />
            )}

        </div>
    );
}

export default Home;
